import permissions from '@/constants/permissions'

const ChildCard = () => import('@/views/dashboard/ChildCard.vue')

export default [
  {
    path: '/karta-dziecka/:childEditionId',
    name: 'ChildCard',
    component: ChildCard,
    props: true,
    meta: {
      requireAuth: true,
      permission: [permissions.childEditionView, permissions.assignedChildEditionView]
    }
  },
  {
    path: '/karta-dziecka-koordynator-szkolny/:childEditionId',
    name: 'CoordinatorsChildCard',
    component: ChildCard,
    props: true,
    meta: {
      requireAuth: true,
      permission: permissions.coordinatorChildEditionDetailsView
    }
  }
]
